module.exports = __webpack_public_path__ + "img/bh_10.205d06dc.jpg";